import { twMerge } from "tailwind-merge";
import { IssuerLogo } from "views/issuerDetails/components/IssuerLogo";
import { LogoOption } from "./types";

interface IssuerSelectProps {
  onSelect: (ids: string[]) => void;
  selected: string[];
  issuers: LogoOption[];
}

export const IssuerSelect = ({
  issuers = [],
  selected,
  onSelect,
}: IssuerSelectProps) => {
  const handleClick = (id: string) => {
    const newSelected = selected.includes(id)
      ? selected.filter((selectedId) => selectedId !== id)
      : [...selected, id];

    onSelect(newSelected);
  };

  if (issuers.length === 0) {
    return (
      <div className="w-full text-center">
        <span className="text-sm text-primary-40">
          Inga fondbolag som matchar din filtrering
        </span>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-2">
      {issuers.map((issuer) => (
        <Box
          key={issuer.id}
          {...issuer}
          isSelected={selected.includes(issuer.id)}
          onClick={() => handleClick(issuer.id)}
        />
      ))}
    </div>
  );
};

interface BoxProps extends LogoOption {
  isSelected: boolean;
  onClick: () => void;
}

const Box = ({ name, logoUrl, isSelected, onClick }: BoxProps) => (
  <button
    type="button"
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
    className={twMerge(
      "min-h-10 py-1 border flex-row rounded bg-white-100 border-primary-20 flex items-center justify-start transition-colors",
      isSelected && "bg-secondary-5 border-secondary-100"
    )}
  >
    {/* Same presentation as the logo column on the issuers page
        (views/issuers/components/IssuersTable). IssuerLogo renders nothing when
        src is empty, so an issuer without a logo degrades to name-only. */}
    <IssuerLogo
      src={logoUrl ?? ""}
      name={name}
      className="ml-2 h-8 w-8 shrink-0 rounded-md shadow-sm"
    />

    <span className="pl-2 text-sm text-left">{name}</span>
  </button>
);
